/* eslint-disable react/jsx-no-undef */
import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import Home from "./components/Home";
import AuditReport from "./components/pages/AuditReport";
import TermsAndCondition from "./components/pages/TermsandCondition";
import DataPrivacy from "./components/pages/DataPrivacy";

function App() {
  return (
    <div className="page">
      <Router>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route path="/vulnerability-scan" component={Home} />
          <Route path="/scan-result" component={AuditReport} />
          <Route path="/terms-and-cons" component={TermsAndCondition} />
          <Route path="/data-privacy" component={DataPrivacy} />
        </Switch>
      </Router>
    </div>
  );
}

export default App;
